import { defineComponent as _defineComponent } from 'vue'
import { computed } from '@nuxtjs/composition-api';
import { useBreakpoint, useMediaAsset } from '~/composables';
import CategoryFeaturesBlocks from '~/components/sections/categorySection/CategoryFeaturesBlocks.vue';
import CategoryFeaturesBlocksMobile from '~/components/sections/categorySection/CategoryFeaturesBlocksMobile.vue';

interface Props {
  data?: { id?: string; items: any[] };
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CategoryFeatures',
  props: {
    data: { default: () => ({ items: [] }) }
  },
  setup(__props: any) {

const props = __props as { data: { id?: string; items: any[] } };



const { getAssetUrl } = useMediaAsset();
const { isBiggerThanBreakpoint: isDesktop } = useBreakpoint('md');

const items = computed(() =>
  props.data?.items?.map((item: any) => ({
    ...item,
    image: getAssetUrl(item.image),
  })),
);

return { __sfc: true,props, getAssetUrl, isDesktop, items, CategoryFeaturesBlocks, CategoryFeaturesBlocksMobile }
}

})